import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";
import ProductCard from "@/components/product-card/product-card";
import ProductCardSkeleton from "@/components/product-card/product-card-skeleton";
import Layout from "@/layout/layout";
import Image from "next/image";
import { wrapper } from "@/store";
import { setPath, setTitle } from "@/store/slices/helmet";
import styles from "@/styles/product_list.module.scss";
import Script from "next/script";
import React, { ReactElement, useEffect, useState } from "react";

const DealOfTheDay = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const { data } = await httpClient.get(endpoints.home.dealOfTheDay());
      setData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <section className={styles.product_section}>
        <div className={styles.banner}>
          <Image
            src="https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/9sxp6luJFLBbc0LMrp6O9UHvX7oJWDu8Y3LZ22zO.jpeg"
            alt="DealOfTheDay"
            layout="fill"
            objectFit="cover"
            unoptimized
            priority
          />
        </div>
        <div className={`${styles.container} ${"container"}`}>
          <div className="row g-3 mt-2 mb-3 mt-md-5 mb-md-5">
            {loading ? (
              new Array(8).fill(1).map((_, k) => (
                <div className="col-md-3" key={k}>
                  <ProductCardSkeleton />
                </div>
              ))
            ) : data && data.length > 0 ? (
              data.map((product: any) => (
                <div className="col-lg-3 col-md-6 col-6" key={product.id}>
                  <ProductCard product={product} />
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <p className="fs-5 text-muted fw-semibold mb-0">No records found</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

DealOfTheDay.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ resolvedUrl }) => {
      store.dispatch(setPath(resolvedUrl));
      store.dispatch(setTitle("Deal of The Day"));
      return {
        props: {},
      };
    }
);

export default DealOfTheDay;
